import { get, patch, post } from '@/helpers/httpHandler';
import apartment from "@/components/apartments/Apartment";

export default {
  namespaced: true,

  state: {
    apartments: []
  },

  getters: {},

  mutations: {
    retrievedApartments: (state, apartments) => {
      state.apartments = apartments;
    }
  },

  actions: {
    retrieveApartments: () => get('/apartments'),

    retrieveApartment: (_, apartment) => get(`/apartments/${apartment}`),

    store: (_, apartment) => post('/apartments', apartment),

    update: (_, apartment) => patch(`/apartments/${apartment.id}`, apartment),

    getSmarthomeApartments: () => get('/eliona/apartments'),

    getSmarthomeApartmentById: (_, smarthome_id) => get(`/eliona/apartment/${smarthome_id}`),

    getApartmentInfo: (_, apartment) => get(`/apartments/${apartment}/info`)
  }
};
